import App from "../../../../vendor_core/core/src/App";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";

// Used when the reels cannot be measured
const FALLBACK_WIDTH = 900;

/**
 * The width of the reels on the screen, in CSS pixels: their bounds are in canvas pixels, which the canvas then
 * scales to its size on the page.
 */
export function getReelsWidth(): number {
    try {
        const reels = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .containers.get("reels");
        const canvas = App.instance.view;
        const canvasWidth = canvas.width / App.instance.renderer.resolution;
        const width =
            (reels!.getBounds().width * canvas.getBoundingClientRect().width) /
            canvasWidth;
        return Number.isFinite(width) && width > 0
            ? Math.round(width)
            : FALLBACK_WIDTH;
    } catch (e) {
        return FALLBACK_WIDTH;
    }
}
